// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"9217969c","460":"051a47df","466":"4fb3312d","882":"8ced9aed"}[chunkId] + ".chunk.css";
};